import { render, staticRenderFns } from "./CampaignUserApproved.vue?vue&type=template&id=f6d425a4&scoped=true"
import script from "./CampaignUserApproved.vue?vue&type=script&lang=js"
export * from "./CampaignUserApproved.vue?vue&type=script&lang=js"
import style0 from "./CampaignUserApproved.vue?vue&type=style&index=0&id=f6d425a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d425a4",
  null
  
)

export default component.exports